import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-items: center;
  padding: 24px 20px;
`;

export const titleStyle = css`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #333;
  align-self: flex-start;
`;

export const listContainerStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-items: flex-start;

  ${MEDIA_QUERY_FOR_PC} {
    width: 640px;
  }
  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
    min-width: 360px;
  }
`;
